import { useStaticQuery, graphql } from 'gatsby';

type UseCampaignsProps = {
  magazineId?: string;
  categories?: string[];
};

export const useCampaigns = ({ magazineId, categories }: UseCampaignsProps) => {
  const data = useStaticQuery<Queries.GetAllCampaignsAndMagazinesQuery>(graphql`
    query GetAllCampaignsAndMagazines {
      allCampaigns {
        nodes {
          ...CampaignData
        }
      }
      allMagazines {
        nodes {
          ...MagazineData
        }
      }
    }
  `);
  const allMagazines = [...data.allMagazines.nodes];
  const filteredMagazines =
    categories && allMagazines.filter((magazine) => magazine.categories?.some((categoryId) => categories.includes(categoryId ?? '')));
  const allCampaigns = [...data.allCampaigns.nodes];
  const filteredCampaigns = magazineId
    ? allCampaigns.filter((campaign) => campaign.magazineId === magazineId || campaign.magazineId === 'GENERAL')
    : categories
    ? allCampaigns.filter((campaign) =>
        filteredMagazines?.some((magazine) => campaign.magazineId === magazine.itemId || campaign.magazineId === 'GENERAL')
      )
    : allCampaigns;

  const sortedFilteredCampaigns = filteredCampaigns?.sort((a, b) => (a.magazineId === 'GENERAL' ? 1 : -1));

  return sortedFilteredCampaigns;
};

